var ZoomingStateMachine = require("./zoomingStateMachine.js");
var ZoomingModel = require("./zoomingModel.js");

var Camera2DController = require("./../camera2D/camera2DController.js");
var Editor2DController = require("./../editor2D/editor2DController.js");

var lib_core = require("lib-core");
var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var ZoomingController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        ZOOM_TO_FIT_BUTTON: {id: 'abs_20', name: "ZOOM_TO_FIT_BUTTON", isViewAction: true },
        ZOOM_OUT_BUTTON: {id: 'abs_40', name: "ZOOM_OUT_BUTTON", isViewAction: true},
        ZOOM_IN_BUTTON: {id: 'abs_50', name: "ZOOM_IN_BUTTON", isViewAction: true}
    });

};
lib_core.inherit(ZoomingController, lib_core.Controller);
ZoomingController.inject = {
    editor2DController : Editor2DController,
    camera2DController : Camera2DController
};
if(showUI) {
    ZoomingController.inject.tabController = ui_extensions.TabController;
}

module.exports = ZoomingController;

ZoomingController.prototype.createStateMachine = function () {
    return new ZoomingStateMachine(this.root, this.getModel());
};

ZoomingController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    //disable in view mode
    if (this.tabController && !this.configuration.noButtons){
        this.tabController.getView().registerButton({
            name: 'Zoom Out',
            title: 'Zoom Out (Ctrl + -)',
            sortOrder: 0,
            eventType: lib_core.GuiEvents.ZOOM_OUT_BUTTON,
            style: {
                icon: 'icon-zoom-out.svg'
            },
            group: "navigation",
            scope: this.getModel().scope()
        });
        this.tabController.getView().registerButton({
            name: 'Zoom In',
            title: 'Zoom In (Ctrl + +)',
            sortOrder: 1,
            eventType: lib_core.GuiEvents.ZOOM_IN_BUTTON,
            style: {
                icon: 'icon-zoom-in.svg'
            },
            group: "navigation",
            scope: this.getModel().scope()
        });
        this.tabController.getView().registerButton({
            name: 'Zoom To Fit',
            title: 'Zoom To Fit (Z)',
            sortOrder: 2,
            eventType: lib_core.GuiEvents.ZOOM_TO_FIT_BUTTON,
            style: {
                icon: 'icon-zoom-all.svg'
            },
            group: "navigation",
            scope: this.getModel().scope()
        });
    }
};

ZoomingController.prototype.createModel = function () {
    var editorModel = this.editor2DController.getModel();
    var cameraModel = this.camera2DController.getModel();
    return new ZoomingModel(editorModel, cameraModel);
};

ZoomingController.prototype.afterLoad = function () {
    var self = this;
    var editorController = this.editor2DController;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    editorController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};

